const CompanyFormationTypes = Object.freeze({
  RESIDENT: 1,
  NON_RESIDENT: 2,
});

export default CompanyFormationTypes;
